import React from "react";
import { Grid, Typography, Box } from "@mui/material";

function Header() {
  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)",
        color: "white",
        py: 6,
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "radial-gradient(circle at 30% 50%, rgba(59, 130, 246, 0.1) 0%, transparent 50%)",
          pointerEvents: "none",
        },
      }}
    >
      <Grid container justifyContent="center" sx={{ position: "relative", zIndex: 1 }}>
        <Grid item xs={12} textAlign="center">
          <Typography
            variant="h3"
            fontWeight="700"
            sx={{
              background: "linear-gradient(135deg, #fff 0%, #e0e7ff 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              mb: 1,
              fontSize: { xs: "1.8rem", sm: "2.5rem" },
              letterSpacing: "-0.5px",
            }}
          >
            Power Electro Control India
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: "1rem",
              fontWeight: "500",
              color: "#e0e7ff",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              opacity: 0.9,
            }}
          >
            Pvt. Ltd. • Bengaluru, Karnataka
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Header;
